import { useQuery } from 'react-query'
import { fetchAnnouncements } from '../API'

export default (
  apiData,
  { shouldDisplay, nextPage, filterByUnread, onSuccess }
) => {
  const { isFetching, data, refetch } = useQuery(
    [
      'user-announcements',
      {
        filterByUnread,
        shouldDisplay,
        page: nextPage
      }
    ],
    () => fetchAnnouncements(apiData, nextPage, filterByUnread, onSuccess),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!apiData?.orgId && shouldDisplay,
      initialData: []
    }
  )

  return {
    isFetching,
    data,
    refetch
  }
}
